<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <header style="display: flex;justify-content: space-between;">
      <div>
        <el-button-group>
          <span style="font-size: 14px;">分配时间:</span>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectTime"
            clearable
            style="width: 240px; margin-right: 10px"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <span style="font-size: 14px;">添加状态:</span>
          <el-select
            v-model="formData.status"
            placeholder="请选择"
            size="mini"
            @change="selectStatus"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
      </div>
    </header>
    <div class="table-content">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 290px)"
        :default-sort="{ prop: 'sendTotal', order: 'descending' }"
      >
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="cusPhone" label="手机号码" width="280">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.cusPhone }}
            <el-button
              size="mini"
              type="primary"
              @click="handleCopy(scope.row.cusPhone, '复制成功', scope.row.id)"
              v-if="scope.row.taskStatus != 2"
              >复制号码</el-button
            >
            <el-button size="mini" type="info" v-if="scope.row.taskStatus == 2"
              >空号</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="cusName" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="remark" label="备注信息"> </el-table-column>
        <!-- <el-table-column prop="allocationStatus" label="分配状态">
          <template slot-scope="scope">
            {{ scope.row }}
            {{ allENUM[scope.row.allocationStatus] }}
          </template>
        </el-table-column> -->
        <el-table-column prop="taskStatus" label="添加状态">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-tag
              v-if="scope.row.taskStatus === 1"
              type="success"
              size="mini"
            >
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
            <el-tag
              v-else-if="scope.row.taskStatus === 0"
              type="danger"
              size="mini"
            >
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
            <el-tag v-else :type="'warning'" size="mini">
              {{ taskStatusENUM[scope.row.taskStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="approvalStatus" label="通过情况">
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            <el-tag
              :type="scope.row.approvalStatus === 1 ? 'success' : 'danger'"
              size="mini"
            >
              {{ approvalENUM[scope.row.approvalStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作">
          <template slot-scope="scope">
            <a
              @click="handleTabPhone(scope.row.id, 2)"
              style="color: #409eff;cursor: pointer;"
              v-if="scope.row.taskStatus != 2"
              >标记为空号</a
            >
            <a
              @click="handleTabPhone(scope.row.id, 1)"        
              style="color: #409eff;cursor: pointer;"
              v-if="scope.row.taskStatus == 2"
              >解除标记?</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
  </div>
</template>

<script>
import {
  getEmpList,
  postUpdateTask,
} from "../../../api/addFriends/addFriends.js";
import dayjs from "dayjs";
import request from "../../../utils/request";
export default {
  name: "MyTasks",
  data() {
    return {
      formData: {
        userId: localStorage.getItem("userId"),
        sceneName: "",
        startTime: "",
        endTime: "",
        status: "0",
      },
      searchSelectTime: [],
      tableData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 20, 50, 100, 200, 500],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "未添加",
        },
        {
          value: "1",
          label: "已添加",
        },
        {
          value: "2",
          label: "空号",
        },
      ],
      allENUM: {
        0: "未分配",
        1: "已分配",
      },
      taskStatusENUM: {
        0: "未添加",
        1: "已添加",
        2: "报告为空号",
      },
      approvalENUM: {
        0: "未通过",
        1: "已通过",
      },
      value: "",
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    async handleTabPhone(id, val) {
      console.log(
        { id: id, taskStatus: val },
        localStorage.getItem("Authorization")
      );
      let res = await postUpdateTask(
        { id: id, taskStatus: val },
        localStorage.getItem("Authorization")
      );
      if (res.error.code == 200) {
        // this.getTagsGroup();
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      }
      console.log("--------------------", res);
      this.getDataList();
    },
    handleClick() {},
    handleCopy(content, tipString = "复制成功", id) {
      const input = document.createElement("input");
      input.setAttribute("value", content);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      // this.$message.success(tipString);
      this.handleTabPhone(id, 1);
    },
    searchFn() {},
    async getDataList() {
      const res = await getEmpList(
        {
          userId: JSON.parse(localStorage.getItem("userId")),
          status: this.formData.status,
          current: this.pageparm.currentPage,
          size: this.pageparm.pageSize,
          startTime: this.formData.startTime,
          endTime: this.formData.endTime,
        },
        localStorage.getItem("Authorization")
      );
      this.tableData = res.data.result;
      this.pageparm.total = res.data.total;
    },
    // 时间处理
    selectTime(dataTime) {
      if (dataTime == null) {
        this.formData.startTime = "";
        this.formData.endTime = "";
      } else {
        // this.formData.startTime = dataTime[0];
        // this.formData.endTime = dataTime[1];
        this.formData.startTime = dayjs(dataTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        this.formData.endTime = dayjs(dataTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      this.pageparm.currentPage = 1;
      this.getDataList();
    },
    // 状态处理
    selectStatus(val) {
      console.log("转太发生改变", val);
      this.pageparm.currentPage = 1;
      this.formData.status = val;
      this.getDataList();
    },
    callBack(parm) {
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getDataList();
    },
    handleChange() {},
  },
};
</script>
